<template>
<div>
  <div class="cont">
    <div class="container">
      <!-- <Head :active="'FAQ'" /> -->
      <!-- <banner /> -->
      <div :class="{list:true,lister:listshow}">
        <span class="title">项目案例
          <!-- {{center.CENTER_TITLE}} -->
        </span>
        <div class="text">Project Case
          <!-- {{center.CONTER_TEXT}} -->
        </div>
      </div>
    </div>
  </div>
<!-- <div :class="{example:true,joiner:joinershow}"> -->
  <!-- filter((x) => {return x.tid % 2 !== 0}) -->
  <div class="example" v-for="(art, idx) in example.slice(0,6)" :key="'article'+idx">
    <div class="item" v-if="art.tid % 2 !== 0">
      <div :class="{itemimg:true,itemimger:itemimgershow}">
        <img style="width:100%" :src="art.photo" alt="">
      </div>
      <div :class="{itemtext:true,itemtexter:itemtextershow}">
        <br>
        <p class="pone">{{art.tit}}</p>
        <br>
        <p class="ptwo">{{art.con}}</p>
        <br><router-link :to="'/example/view/'+art.tid">
        <button class="button">了解详情</button></router-link>
      </div>
    </div>
    <div class="item" v-else style="flex-flow: row-reverse;">
      <div :class="{itemimg:true,itemimger:itemimgershow}">
        <img style="width:100%" :src="art.photo" alt="">
      </div>
      <div :class="{itemtext:true,itemtexter:itemtextershow}">
        <br>
        <p class="pone">{{art.tit}}</p>
        <br>
        <p class="ptwo">{{art.con}}</p>
        <br><router-link :to="'/example/view/'+art.tid">
        <button class="button">了解详情</button></router-link>
      </div>
    </div>
</div>
  <!-- <Footer /> -->
</div>
</template>

<script>
import axios from 'axios'
import Head from '../../components/header.vue'
import banner from '../../components/banner.vue'
import Footer from '../../components/footer.vue'
export default {
  components: {
    Head,
    banner,
    Footer
  },
  data () {
    return {
      listshow: true,
      itemimgershow: false,
      itemtextershow: false,
      linkconershow: false,
      pinershow: false,
      example: []
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    axios.get(`https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/example.json`)
      .then(response => {
        // this.center = response.data.CENTER
        this.example = response.data
        // this.twocons = response.data.CENTER.CONTER_TWO
        // console.log(this.center)
      })
  },
  methods: {
    handleScroll () {
      this.currentScroll = window.pageYOffset
      // console.log(this.currentScroll)
      if (this.currentScroll >= 0) {
        // console.log(this.currentScroll)
        this.itemimgershow = true
        this.itemtextershow = true
      }
      if (this.currentScroll >= 0) {
        this.itemimgshow = true
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../../../static/less/less.css');
@media only screen and (min-width: 960px) {
  .item {
    display: flex;
    .itemimg {
      width: 50%;
    }
    .itemtext {
      padding: 3% 5%;
      width: 50%;
    }
  }
}
@media only screen and (min-width: 767px) and (max-width: 960px) {
  .item {
    display: inline-flex;
    .itemimg {
    width: 50%;
    }
    .itemtext {
      padding: 50px 20px 50px 20px;
      width: 50%;
    }
    .item_qr {
      width: 100%;
    }
  }
}
//<1100
@media only screen and (max-width: 767px) {
  .item {
    // display: inline;
    display: inline-table;
    .itemimg {
      width: 100%;
    }
    .itemtext {
      padding: 50px 20px 50px 20px;
      width: 100%;
    }
    .item_qr {
      width: 100%;
    }
  }
}
.cont {
  text-align: center;
  padding-top: 80px;
  display: flex;
  // min-width: 1200px;
  .container {
  width: 96%;
  // padding: 55px 10% 60px 10%;
  background-color: #fdfffc;
  margin: 0 auto;
  max-width: 1200px;
  .lister {
    position: relative;
    animation-name: FadeDown;
    animation-duration: 1.5s;
    opacity: 1 !important;
  }
  .list {
    // position: relative;
    // animation-name: FadeDown;
    // animation-duration: 1.5s;
    // opacity: 0;
    text-align: center;
    margin-bottom: 30px;
    .title {
      font-size: 28px;
      font-weight: bold;
      color: #333;
    }
    .text {
      color: #818181;
      font-size: 18px;
    }
  }
  }
}
// .joiner {
//   animation-name: fadeUp;
//   visibility: visible;
//   animation-duration: 2s;
//   opacity: 1 !important;
// }
.example {
  padding: 0px 0;
  width: 96%;
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  // opacity: 0;
  .item {
    padding: 0px;
    margin: 20px 0px 0px;
    width: 100%;
    height: 318px;
    // border: 1px solid rgb(217, 217, 217);
    color: rgb(126, 126, 126);
    font-size: 14px;
    line-height: 18px;
    // opacity: 0;
  }
  .itemimger {
    animation-name: fadeRight;
    visibility: visible;
    animation-duration: 2s;
    opacity: 1 !important;
  }
  .itemimg {
    // border-width: 0px 1px 0px 0px;
    // border-right-style: solid;
    // border-right-color: #d9d9d9;
    overflow: hidden;
    // visibility: visible;
    display: block;
    float: left;
    height: 318px;
    opacity: 0;
    // width: 50%;
    img {
      height: 318px;
      // width: 100%;
    }
  }
  .itemtexter {
    animation-name: fadeLeft;
    visibility: visible;
    animation-duration: 2s;
    opacity: 1 !important;
  }
  .itemtext {
    opacity: 0;
    float: left;
    // width: 50%;
    // padding: 70px 0 50px 50px;
    text-align: left;
    line-height: 25px;
    .pone {
      // padding-bottom: 20px;
      font-size: 22px;
      // font-weight: bold;
      // text-align: center;
      line-height: 25px;
      // border-bottom: 1px solid #ddd;
    }
    .ptwo {
      font-size: 15px;
      height: 70px;
      overflow: hidden;
      word-break: break-word;
      text-overflow: ellipsis;
    }
    .button {
      position: relative;
      // animation-name: FadeUp;
      // animation-duration: 1.5s;
      background-color: #3B9FF2;
      width: 150px;
      height: 40px;
      margin-top: 20px;
      border: none;
      cursor: pointer;
      color: #fdfffc;
      border: solid 1px #fdfffc;
      border-radius: 3px;
      // transition: all 0.3s;
      // z-index: 3;
    }
    .button:hover {
      background: #fdfffc;
      color: #3B9FF2;
      transition: all .3s ease-in-out;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/example/example-listt.vue